import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Radiobutton.scss';

class RadioButton extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { name, checked, value } = e.target;

    if (typeof this.props.onChange == 'function') {
      this.props.onChange({ name, checked, value });
    }
  }

  render() {
    const { name, value, label, id, disabled, checked } = this.props;

    return (
      <label className='radio_button'>
        {label}
        <input
          name={name}
          id={id}
          value={value}
          checked={checked}
          type="radio"
          disabled={disabled}
          onChange={this.handleChange}
        />
        <span className='checkmark'></span>
      </label>
    );
  }
}

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default RadioButton;
